<template>
  <iframe :id="id" ref="video" 
    width="100%" height="100%" 
    frameborder="0" allow="autoplay" 
    webkitallowfullscreen mozallowfullscreen allowfullscreen>
  </iframe>
</template>

<script>
  export default {
    name: 'VideoVimeo',
    props: {
      data: {
        type: Object,
        default: null
      },
      id: {
        type: String
      },
      autoplay: {
        type: Boolean
      }
    },
    data() {
      return {
        player: null,
      }
    },
    created() {
      window.console.log('Loading Vimeo Player.')

      // payload (id+command)
      this.$root.$on('vt-change-video', (payload) => {
        if (payload.id !== this.id) return

        if (payload.command === 'stop') {
          this.player.unload()
        }

        if (payload.command === 'play') {
          this.player.play()
        }
      })
    },
    mounted() {
      if (!this.data) return

      const { video } = this.$refs
      video.src = `${this.data.url}?api=1`

      // eslint-disable-next-line
      this.player = new Vimeo.Player(video)

      if (this.autoplay) {
        this.player.on('loaded', () => {
          this.player.play()
        })
      }
    }
  }
</script>

<style lang="sass">
  
</style>
